import iconFolder from '@/assets/img/disk/folder.svg'
import iconImage from '@/assets/img/disk/image.svg'
import iconVideo from '@/assets/img/disk/video.svg'
import iconAudio from '@/assets/img/disk/audio.svg'
import iconPdf from '@/assets/img/disk/pdf.svg'
import iconWord from '@/assets/img/disk/word.svg'
import iconExcel from '@/assets/img/disk/excel.svg'
import iconPpt from '@/assets/img/disk/ppt.svg'
import iconZip from '@/assets/img/disk/zip.svg'
import iconText from '@/assets/img/disk/text.svg'
import iconFile from '@/assets/img/disk/file.svg'

const FILE_ICON_EXTS = [
  [iconImage, ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg', 'heic', 'heif', 'tif', 'tiff', 'ico']],
  [iconVideo, ['mp4', 'mov', 'avi', 'mkv', 'wmv', 'flv', 'webm', 'm4v', '3gp', 'mpg', 'mpeg', 'rmvb']],
  [iconAudio, ['mp3', 'wav', 'aac', 'flac', 'm4a', 'ogg', 'wma', 'amr', 'ape']],
  [iconPdf, ['pdf']],
  [iconWord, ['doc', 'docx', 'wps', 'rtf', 'dot', 'dotx']],
  [iconExcel, ['xls', 'xlsx', 'csv', 'et', 'xlsm']],
  [iconPpt, ['ppt', 'pptx', 'pps', 'ppsx', 'dps', 'key']],
  [iconZip, ['zip', 'rar', '7z', 'tar', 'gz', 'tgz', 'bz2', 'xz']],
  [iconText, ['txt', 'md', 'log', 'json', 'xml', 'html', 'htm']]
]
const FILE_ICON_MAP = {}
FILE_ICON_EXTS.forEach(function (pair) {
  pair[1].forEach(function (ext) {
    FILE_ICON_MAP[ext] = pair[0]
  })
})

export {iconFolder, iconFile}

export function fileIconOf (name, isFolder) {
  if (isFolder) {
    return iconFolder
  }
  let text = String(name || '')
  let dot = text.lastIndexOf('.')
  let ext = dot >= 0 ? text.slice(dot + 1).toLowerCase() : ''
  return FILE_ICON_MAP[ext] || iconFile
}



// WEBPACK FOOTER //
// ./src/components/disk/fileIcon.js